import React, { useEffect } from "react";
import firebase from "firebase/compat/app";
import { ENV, isNullOrEmpty } from "../config/ENV";
import { employeerAuthService } from "../../src/services/AuthService";
firebase.initializeApp(ENV.firebaseConfig);
const token = window.localStorage.getItem("authToken");

const AuthVerify = (props) => {
  useEffect(() => {
    if (!isNullOrEmpty(window.localStorage.getItem("authTokenExpirationTime"))) {
     var authTokenExpirationTime=window.localStorage.getItem("authTokenExpirationTime");
     var currentTime = new Date().getTime();  
     let timeDuriation=5*60000;
     authTokenExpirationTime=authTokenExpirationTime-timeDuriation;
     if(currentTime>authTokenExpirationTime){
      refreshToken();     
     }
    }else{
      refreshToken();
    }
  }, [props]);

  const refreshToken=()=>{   
    firebase.auth().onAuthStateChanged(function (user) { 
    if (user) {
      user.getIdToken().then(function (idToken) {
        window.localStorage.setItem("authToken", idToken);
        try{
          if(user!=null){
            let stsTokenManager=user.toJSON().stsTokenManager;
            if(stsTokenManager!=null){
              let expirationTime=stsTokenManager.expirationTime;
              if(expirationTime!=null){
                window.localStorage.setItem("authTokenExpirationTime", expirationTime);
              }
            }
          }
        } catch (err) {}

        login();
      });
    }
  });
  }

  const login = () => {   
    employeerAuthService().then((response) => {
      if (response.data !== undefined && response.data !== "") {
        if (response.status == 200) {
          const loginResposne = response.data;
          window.localStorage.setItem("user", loginResposne.id);

          if (loginResposne.email !== null) {
            window.localStorage.setItem("email", loginResposne.email);
          }

          if (loginResposne.firstName !== null) {
            window.localStorage.setItem("name", loginResposne.firstName);
          }
          if (loginResposne.lastName !== null) {
            window.localStorage.setItem("lastName", loginResposne.lastName);
          }

          if (loginResposne.contactNumber !== null) {
            window.localStorage.setItem(
              "phoneNumber",
              loginResposne.phoneNumber
            );
          }
          window.localStorage.setItem(
            "employerName",
            loginResposne.employerName
          );
          if (loginResposne.role !== null) {
            window.localStorage.setItem("userRole", loginResposne.role);
          }
        }
      }
    });
  };
  return <></>;
};
export default AuthVerify;
